var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"track",rawName:"v-track",value:({functionName: '每日一题'}),expression:"{functionName: '每日一题'}"}],staticClass:"day-answer",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"img-bg",attrs:{"src":require("../../../assets/images/questionBank/img(18).png"),"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e19120c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/components/DayAnswer.vue
// module id = null
// module chunks = 